import { ChangeEvent, memo, SetStateAction } from 'react';
import { Track } from './model/Track';
import { logPrefix } from './util/Log';
import { parseDate } from './util/Time';

type TrackRowProps = {
  track: Track,
  isCurrent: boolean,
  playTrack: (track: Track) => void,
  onChangeTrack: (track: Track) => void
};

export default memo(function TrackRow(
  { track, isCurrent, playTrack, onChangeTrack }: TrackRowProps) {

  function handleChangeEnable(event: ChangeEvent<HTMLInputElement>) {
    track.enable = event.target.checked;
    onChangeTrack(track);
  }

  function handleChangeStar(event: ChangeEvent<HTMLSelectElement>) {
    const star = Number(event.target.value);
    track.star = star;
    onChangeTrack(track);
  }

  function handleChangeMemo(event: ChangeEvent<HTMLInputElement>) {
    track.memo = event.target.value;
    onChangeTrack(track);
  }
  ////////////////// end of function

  const releaseDate = parseDate(track.releaseDate);

  console.debug(logPrefix(), 'TrackRow lender title:' + track.title);
  return (
    <tr key={track.id} className={`trackRow track-${track.id} ${isCurrent ? 'current' : ''}`}>
      <td>
        <input type='checkbox' className='checkbox clickable'
          onChange={handleChangeEnable}
          checked={track.enable}
        />
      </td>
      <td>
        <span onClick={() => playTrack(track)} className='clickable'>{track.title}</span>
        <br />
        <span onClick={() => playTrack(track)} className='clickable'>{track.musician}</span>
      </td>
      <td>
        {track.isNew && <><span className='new'>NEW</span><br /></>}
        {releaseDate.yyyy}/<br />{releaseDate.mm}/{releaseDate.dd}
      </td>
      <td>
        <select
          value={track.star}
          onChange={handleChangeStar}>
          <option value="0"></option>
          <option value="1">★</option>
          <option value="2">★★</option>
          <option value="3">★★★</option>
        </select>
      </td>
      <td>
        <input className='memo'
          value={track.memo}
          onChange={handleChangeMemo}
          placeholder='メモ' />
      </td>
    </tr>
  );
})
/////////////////////////////////////////////////////////////////////////////
